import React, { useEffect, useState } from "react"
import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme
} from "@mui/material"
import TableNoRecords from "components/TableNoRecords"
import AppButton from "components/StyledComponents/AppButton"
import { useDispatch, useSelector } from "react-redux"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { getRestaurantGroupAction } from "redux/DMV/actions/user"
import AppPagination from "components/StyledComponents/AppPagination"
import { DMVActions } from "redux/DMV/slice/user"
import { formatDates } from "helpers/functions"
import { appActions } from "redux/app/slice/app"

const CustomTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  borderCollapse: "collapse !important",
  "& .MuiTableCell-root": {
    padding: "12px 24px 12px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: "none",
    boxSizing: "border-box",
    "&:last-child": { paddingRight: 0 }
  },
  "& .MuiTableRow-root": {
    borderBottom: `2px solid ${theme.palette.background.default}`
  },
  "& .MuiTableCell-head": {
    position: "relative",
    padding: "24px 24px 12px 0px",
    "&:last-child": {
      paddingRight: 24,
      textAlign: "right"
    }
  }
}))
const GroupLeaderBoardList = () => {
  const [breadCrumbs, setBreadcrumbs] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [groupLeaderboardList, setGroupLeaderboardList] = useState([])
  const { groupLeaderboardData } = useSelector((store) => store?.dmv)
  const { isLoading } = useSelector((store) => store.app)
  const theme = useTheme()
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const itemsPerPage = 10
    const totalPages = Math.ceil(groupLeaderboardData?.length / itemsPerPage)
    const paginatedGroupLeaderboardList = groupLeaderboardData?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    )
    setGroupLeaderboardList(paginatedGroupLeaderboardList)
    setPages(totalPages)
  }, [groupLeaderboardData, currentPage])

  useEffect(() => {
    document.title = "Group LeaderBoard List"
    setBreadcrumbs(createBreadcrumbs())
    dispatch(getRestaurantGroupAction({ cms: true }))
  }, [])

  return (
    <>
      <Header title={"Group LeaderBoard"} breadCrumbs={breadCrumbs} />
      <Paper>
        <TableContainer sx={{ maxHeight: 700 }}>
          <CustomTable stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "10px" }}>
                  <Typography
                    variant="body4Regular"
                    color={theme.palette.text.secondary}
                    style={{ opacity: 0.6 }}>
                    #
                  </Typography>
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}>
                    <Typography
                      variant="body4Regular"
                      color={theme.palette.text.secondary}
                      style={{ opacity: 0.6 }}>
                      {column.label}{" "}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {groupLeaderboardList?.length ? (
                groupLeaderboardList?.map((row, index) => {
                  return (
                    <TableRow key={row.id}>
                      <TableCell>
                        <Typography variant="body1Regular" color={theme.palette.text.primary}>
                          {String(currentPage * 10 - 10 + index + 1).padStart(2, "0")}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body1Regular" color={theme.palette.text.primary}>
                          {row.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body1Regular" color={theme.palette.text.primary}>
                          {formatDates(row.created_at)}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <AppButton
                          variant="outlined"
                          styles={{ padding: "5px 20px", marginLeft: "10px" }}
                          onClick={() => {
                            dispatch(DMVActions.setGroupId(row.id))
                            dispatch(appActions.initFilters())
                            history.push("/marketing/dashboard/leaderboard/group-leaderboard")
                          }}>
                          View
                        </AppButton>
                      </TableCell>
                    </TableRow>
                  )
                })
              ) : (
                <TableNoRecords
                  colSpan={8}
                  label={
                    isLoading ? "Please wait we are fetching the groups..." : "No Group  Found"
                  }
                />
              )}
            </TableBody>
          </CustomTable>
          {groupLeaderboardData?.length ? (
            <AppPagination
              onPageChange={setCurrentPage}
              totalPages={pages}
              currentPage={currentPage}
            />
          ) : (
            ""
          )}
        </TableContainer>
      </Paper>
    </>
  )
}

export default GroupLeaderBoardList

const columns = [
  {
    id: "2",
    label: "Name",
    minWidth: 200,
    align: "left"
  },
  {
    id: "3",
    label: "Created On",
    minWidth: 400,
    align: "left"
  },
  {
    id: "4",
    label: "Action",
    minWidth: 100,
    align: "right"
  }
]
